/**
 * Packaging OS — site footer.
 */

interface FooterProps {
  copyright: string;
}

export function Footer({ copyright }: FooterProps): JSX.Element {
  return (
    <footer className="po-footer">
      <span>{copyright}</span>
      <span aria-hidden="true">·</span>
      <span className="dir-ltr-island">drkhorramymehronline.com</span>
    </footer>
  );
}
